import { DiscountApplicationTypeNotEmpty } from "./offers";

/**
 * Experience "modules" — the modification-type segmentation used by the
 * unified Experiences nav. Unlike {@link ExperienceCategory} (experiment vs
 * personalization), a module describes the *kind of modification(s)* an
 * experience contains, and is category-agnostic (a module returns both
 * experiments and always-on personalizations).
 *
 * Mapping to underlying modifications:
 * - content       → onsite edits, on-site CSS/JS injections, or redirects (incl. theme/template)
 * - checkout      → non-post-purchase checkout blocks (trustBadge, upsell, timer, …)
 * - postPurchase  → post-purchase checkout blocks (block_type === "postPurchaseUpsell")
 * - pricing       → pricing experiences (experience.type === "pricing" or a price product variant)
 * - merchandising → offers with discountApplicationType in {tieredDiscount, cartDiscount, freeGift, buyXGetY}
 * - shipping      → shipping rate groups, or offers with discountApplicationType === "freeShipping"
 */
export const ExperienceModuleList = [
  "content",
  "checkout",
  "postPurchase",
  "pricing",
  "merchandising",
  "shipping",
] as const;

export type ExperienceModule = (typeof ExperienceModuleList)[number];

/**
 * The experience module an offer belongs to, keyed by its discount
 * application type. The single source for "is this offer merchandising or
 * shipping?" — the backend list classifier and the frontend billing gates
 * both derive from it.
 */
export const EXPERIENCE_MODULE_BY_OFFER_TYPE: Readonly<
  Record<DiscountApplicationTypeNotEmpty, ExperienceModule>
> = {
  tieredDiscount: "merchandising",
  cartDiscount: "merchandising",
  freeGift: "merchandising",
  buyXGetY: "merchandising",
  freeShipping: "shipping",
};
